import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import {useSelector } from "react-redux";
import {Loader} from '../../components/Layout/Loader'
import "./Breadc.scss";

const Breadc = ({ data }) => {

  const { categories = [] } = useSelector((state) => state.category || {});
  const { subcategories = [] } = useSelector((state) => state.subcategories || {});
  const { subsubcategories = [] } = useSelector((state) => state.subsubcategories || {});

  const firstCategory = useMemo(() => {
    const categoryId =
      Array.isArray(data.category) && data.category.length > 0
        ? data.category[0]
        : null;
    if (!categoryId) return null;
    return categories.find((c) => c._id === categoryId) || null;
  }, [categories, data.category]);

  const firstSubcategory = useMemo(() => {
    const subcategoryId =
      Array.isArray(data.subcategory) && data.subcategory.length > 0
        ? data.subcategory[0]
        : null;
    if (!subcategoryId) return null;
    return subcategories.find((sc) => sc._id === subcategoryId) || null;
  }, [subcategories, data.subcategory]);

  const firstSubSubcategory = useMemo(() => {
    const subsubcategoryId =
      Array.isArray(data.subsubcategory) && data.subsubcategory.length > 0
        ? data.subsubcategory[0]
        : null;
    if (!subsubcategoryId) return null;
    return subsubcategories.find((ssc) => ssc._id === subsubcategoryId) || null;
  }, [subsubcategories, data.subsubcategory]);

  const isLoading = useMemo(() => {
    const needCat = Array.isArray(data.category) && data.category.length > 0;
    const needSub = Array.isArray(data.subcategory) && data.subcategory.length > 0;
    const needSubSub =
      Array.isArray(data.subsubcategory) && data.subsubcategory.length > 0;

    if (needCat && categories.length === 0) return true;
    if (needCat && !firstCategory) return true;
    if (needSub && subcategories.length === 0) return true;
    if (needSub && !firstSubcategory) return true;
    if (needSubSub && subsubcategories.length === 0) return true;
    if (needSubSub && !firstSubSubcategory) return true;

    return false;
  }, [
    data.category,
    data.subcategory,
    data.subsubcategory,
    categories,
    subcategories,
    subsubcategories,
    firstCategory,
    firstSubcategory,
    firstSubSubcategory,
  ]);

  if (isLoading) {
    return (
      <nav aria-label="breadcrumb" className="breadc-nav">
        <ol className="breadc-list">
          <li className="breadc-item"><Loader/></li>
        </ol>
      </nav>
    );
  }

  return (
    <nav aria-label="breadcrumb" className="breadc-nav">
      <ol className="breadc-list">

        <li className="breadc-item">
          <Link to="/" className="breadc-link">
            Головна сторінка
          </Link>
        </li>

        {firstCategory && (
          <>
            <li className="breadc-separator">&gt;</li>
            <li className="breadc-item">
              <Link to={`/products/${firstCategory._id}`} className="breadc-link">
                {firstCategory.name}
              </Link>
            </li>
          </>
        )}

        {firstSubcategory && (
          <>
            <li className="breadc-separator">&gt;</li>
            <li className="breadc-item">
              <Link to={`/productss/${firstSubcategory._id}`} className="breadc-link">
                {firstSubcategory.name}
              </Link>
            </li>
          </>
        )}

        {firstSubSubcategory && (
          <>
            <li className="breadc-separator">&gt;</li>
            <li className="breadc-item">
              <Link to={`/items/${firstSubSubcategory._id}`} className="breadc-link">
                {firstSubSubcategory.name}
              </Link>
            </li>
          </>
        )}

        {data.name && (
          <>
            <li className="breadc-separator">&gt;</li>
            <li className="breadc-item text-gray-500">{data.name}</li>
          </>
        )}
      </ol>
    </nav>
  );
};

export default Breadc;
